<template>
    <div>
      <div v-if = "showModel==='modelBaseinfo'">
        <van-cell-group title="个人基本信息">
          <van-cell v-for="(item, index) in personShowList"
              :key="index"
              :title="item.title"
              :value="item.info"
          />
        </van-cell-group>
        <van-cell-group title="贷款信息">
          <van-cell title="贷款账号" :value="loanShowObject.dkzh"/>
          <van-cell title="贷款余额" :value="loanShowObject.dkye"/>
          <van-cell title="房屋坐落" :value="loanShowObject.fwzl"/>
          <van-cell title="贷款金额" :value="loanShowObject.dkje"/>
          <van-cell title="贷款合同开始日期" :value="loanShowObject.dkksrq"/>
          <van-cell title="贷款合同结束日期" :value="loanShowObject.dkjsrq"/>
          <van-cell title="还款日" :value="loanShowObject.hkr"/>
        </van-cell-group>
        <van-cell-group title="结算信息">
          <van-cell title="去年商贷实际还款额" :value="loanShowObject.synhkhj"/>
          <van-cell title="商贷已提取额" :value="loanShowObject.ytqe"/>
          <van-cell title="可提取金额" :value="loanShowObject.ktqje"/>
          <van-field
              v-model="tqje"
              label="提取金额"
              input-align="right"
              maxlength="10"
              placeholder="请输入提取金额"
              type="digit"
              @input="inputStr('tqje')"
              class="van-require-patch"
          />
          <van-cell title="其中提取公积金金额" :value="tqgjjje" />
          <van-cell title="其中提取补贴金额" :value="tqbtje" />
          <van-cell v-for="(item, index) in jsShowList"
                    :key="index"
                    :title="item.title"
                    :value="item.info"
          />
        </van-cell-group>
        <van-button type="default" size="normal" color="#518ede" @click="showExtract" :square="true" :block="true">下一步</van-button>
      </div>
      <div v-show="showModel==='modelSubmit'">
        <van-cell-group title="业务办理身份认证">
          <van-cell title="中心预留手机号" :value="tel" />

          <van-field
              v-model="msgCode"
              type="number"
              center
              clearable
              label="短信验证码"
              placeholder="请输入短信验证码"
              class="van-require-patch"
              input-align="right"
              maxlength="6"
          >
            <van-button v-if="!isSend" slot="button" size="small" type="primary" @click="getMsgcode">发送验证码</van-button>
            <van-button v-else slot="button" size="small" :disabled="true" color="#666666">重新发送{{countdown}}秒</van-button>
          </van-field>
        </van-cell-group>
        <van-button type="default" size="normal" color="#518ede" @click="doSubmit" :square="true" :block="true">提交</van-button>
      </div>
    </div>
</template>

<script>
    import {Cell, CellGroup, Button, Field, Picker, Popup, DatetimePicker} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';
    import 'vant/lib/button/style';
    import 'vant/lib/field/style';
    import 'vant/lib/picker/style';
    import 'vant/lib/popup/style';
    import 'vant/lib/datetime-picker/style';
    import uuidv1 from 'uuid/v1';

    Date.prototype.Format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }

    export default {
        name: 'repayBusinessExtract',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell,
            vanButton: Button,
            vanField: Field,
            vanPicker: Picker,
            vanPopup: Popup,
            vanDatetimePicker: DatetimePicker
        },
        mounted() {

        },
        data(){
            return {
                loanShowObject:{
                    dkzh:'',
                    dkye:'',
                    fwzl:'',
                    dkje:'',
                    dkksrq:'',
                    dkjsrq:'',
                    hkr:'',
                    ycje:'',
                },
                jsList:[],
                jsShowList:[],
                personShowList:[],
                personList:[],
                grzh:'',
                xingming:'',
                zjhm:'',
                coreUserId:'',
                tqje:'',
                tqgjjje:'',
                tqbtje:'',
                showModel:'',
                tel:'',
                msgCode:'',
                countdown: 60,
                isSend: false,
            }
        },
        created(){
          let self = this;
          self.tel = self.$store.state.btUserInfo.tel;
          self.grzh = self.$store.state.accountNumber.accountNumber;
          self.xingming = self.$store.state.btUserInfo.userName;
          self.zjhm = self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.zjhm;
          self.coreUserId = self.$store.state.btUserInfo.coreUserid;
          if(this.$route.query.hasOwnProperty('dkyhid')) {
            this.dkyhid = this.$route.query.dkyhid;
          }
          this.preValidation();
        },
        methods: {
            //前置校验接口
            preValidation(){
              let self = this;
              self.$http.post('/miapp/H1003/mpaasgatewayunencrypted', {
                ybmapMessage: {
                  grzh: self.grzh,
                  coreUserid: self.coreUserId
                }
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  this.jsList = res.result;
                  this.getPersonInfo();
                } else {
                  self.$utils.alert(res.msg, function(){
                    self.$router.go(-1);
                  });
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            // 获取个人信息
            getPersonInfo(){
              let self = this;
              self.$http.post('/miapp/A2001/mpaasgatewayunencrypted', {
                buztype: 5001,
                usertype: 10,
                ybmapMessage: {
                  cxlx: '03',
                  cxlxz: self.grzh
                }
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  self.personList = res.result;
                  //个人信息处理
                  let obj = ["grzhzt","grzh","dwzh","gjjye","btye","zhhjy"];
                  this.addPersonShowList(res.result,obj);

                  // 从结算信息里面获取缺失的个人信息部分
                  let obj2 = ["zqyhnew","zqjgnew",];
                  this.addPersonShowList(self.jsList,obj2);

                  this.getLoanInfo();
                } else {
                  self.$utils.alert(res.msg, function(){
                    self.$router.go(-1);
                  });
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            //获取贷款信息
            getLoanInfo(){
              let self = this;
              self.$http.post('/miapp/H1004/mpaasgatewayunencrypted' , {
                ybmapMessage: {
                  zgxm:self.xingming,
                  zgsfz:self.zjhm,
                  dkyh:self.dkyhid,
                  grzh:self.grzh
                }
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  // 贷款信息
                  self.loanShowObject = res;

                  //处理结算信息
                  let obj = ["skrmc","skryh","skrzh"];
                  this.addJsShowList(self.jsList,obj);

                  self.showModel = 'modelBaseinfo';
                  self.jumpSignAfter();
                } else {
                  self.$utils.alert(res.msg, function(){
                    self.$router.go(-1);
                  });
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            routingTo(target, query){
                let self = this;
                self.$router.push({
                    path: '/' + target,
                    query: {
                        'openweb': 'paschybrid'
                    }
                });
            },
            returnFieldValue: function(data, name){
              return data.filter(function(item, index){
                if(item.name == name){
                  return item.info;
                }
              })[0].info;
            },
            addPersonShowList(result,titleObj){
              let self = this;
              for(let i = 0;i < titleObj.length;i++){
                for(let j = 0;j < result.length;j++){
                  if(titleObj[i] == result[j].name){
                    self.personShowList.push(result[j]);
                  }
                }
              }
            },
            addJsShowList(result,titleObj){
              let self = this;
              for(let i = 0;i < titleObj.length;i++){
                for(let j = 0;j < result.length;j++){
                  if(titleObj[i] == result[j].name){
                    self.jsShowList.push(result[j]);
                  }
                }
              }
            },
            inputStr(arg) {
              if(arg === 'tqje'){
                let _self = this;
                let _transfamt = _self.tqje;
                _transfamt = _transfamt.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
                _transfamt = _transfamt.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
                _transfamt = _transfamt.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                _transfamt = _transfamt.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数
                if(_transfamt.indexOf(".")< 0 && _transfamt !=""){
                  //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                  _transfamt= parseFloat(_transfamt);
                }
                _self.tqje = _transfamt;

                //提取金额的控制，当提取金额tqje小于补贴余额btye时，优先提取补贴余额(je=tqje,btje=0)；
                // 当提取金额大于补贴余额时，先提取完补贴余额btye(btje=btye),然后剩下的从公积金余额里取（je=tqje-btye）

                if(Number(_self.tqje) * 100 > _self.returnFieldValue(this.personList, 'btye') * 100){
                  _self.tqbtje = _self.returnFieldValue(this.personList, 'btye');
                  _self.tqgjjje = (Number(_self.tqje) * 100 - _self.returnFieldValue(this.personList, 'btye') * 100) / 100;
                }
                if(Number(_self.tqje) * 100 <= _self.returnFieldValue(this.personList, 'btye') * 100){
                  _self.tqbtje = Number(_self.tqje);
                  _self.tqgjjje = 0;
                }
              }
            },
            showExtract(){
              let self= this;
              if(Math.abs(Number(self.tqje)) === 0){
                self.$utils.alert('请输入提取金额！');
                return false;
              }

              if(Math.abs(Number(self.tqje)) % 100 !== 0){
                self.$utils.alert('请输入百元整数倍金额！');
                return false;
              }

              if(Math.abs(Number(self.tqje)) > Number(self.loanShowObject.ktqje)){
                self.$utils.alert('输入金额不可超过您的可提取金额，请重新输入！');
                return false;
              }

              this.showModel = 'modelSubmit';
              this.getSignUrl();
            },
            doSubmit(){
              let self = this;
              let _self = this;

              if(self.msgCode.length !== 6){
                self.$utils.alert('短信验证码为6位数字');
                return false;
              }

              let ybmapMessage = {
                coreUserid: self.coreUserId,
                channel: '11',
                dwzh: self.returnFieldValue(self.personList, 'dwzh'),
                lrrq: new Date().Format("yyyyMMdd"),
                grzh: self.grzh,
                hjny: self.returnFieldValue(self.personList, 'zhhjy'),
                zqjg: self.returnFieldValue(self.jsList, 'zqjg'),
                zqyh: self.returnFieldValue(self.jsList, 'zqyh'),
                skrmc: self.returnFieldValue(self.jsList, 'skrmc'),
                skryh: self.returnFieldValue(self.jsList, 'skryh'),
                skrzh: self.returnFieldValue(self.jsList, 'skrzh'),
                zghjzt: self.returnFieldValue(self.personList, 'jczt'),
                je: self.tqgjjje,
                btje: self.tqbtje,
                gjjye: self.returnFieldValue(self.personList, 'gjjye'),
                btye: self.returnFieldValue(self.personList, 'btye'),
                dkzh: self.loanShowObject.dkzh,
                synhkhj: self.loanShowObject.synhkhj,
                ytqe: self.loanShowObject.ytqe,
                ycje: self.loanShowObject.ycje,
                ktqje: self.loanShowObject.ktqje,
                dkyh: self.dkyhid,
                sjhm: self.tel,
                yzm: self.msgCode
              };

              self.$http.post('/miapp/H1005/mpaasgatewayunencrypted' , {
                money: _self.tqje,
                ybmapMessage: ybmapMessage
              }).then(res => {
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  self.$utils.alert('提交成功！中心将在5个工作日内办结。', () => {
                  });
                  self.doReport();
                } else {
                  self.$utils.alert(res.msg);
                }
                self.$utils.loading(false);
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            doReport(){
              let self = this;
              console.log('baitong', self.$store.state.baitong);
              self.$http.post('/miapp/C0001/mpaasgatewayunencrypted', {
                "accessToken": self.$store.state.baitong.userAccessToken,
                "openId": self.$store.state.btUserInfo.openId,
                "idCard": self.$store.state.btUserInfo.idCard,
                "reportedData": {
                  "serviceId": "偿还商贷提取",
                  "ywName": "偿还商贷提取",
                  "statusNo": "1",
                  "eventName": "偿还商贷提取提交",
                  "orderId": self.$store.state.btUserInfo.idCard + Date.parse(new Date()),
                  "remark": "",
                  "detailInfo": {
                    "APPLICANT_NAME": self.$store.state.btUserInfo.userName,
                    "APPLY_DATE": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                    "ORG_NAME": "南通市住房公积金中心",
                    "process": [
                      {
                        "END_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                        "EVENT_NAME": "偿还商贷",
                        "START_NOTE": "通过",
                        "START_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                        "START_USER_NAME": "南通市住房公积金中心"
                      }
                    ],
                    "statuNO": "1",
                    "smtApplyFile":[]
                  }
                }
              }, {loading: false}).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){

                } else {
                  self.$utils.alert(res.msg || '业务上报失败');
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            // 获取短信验证码
            getMsgcode(){
              let self = this;
              self.$http.post('/miapp/A5009/mpaasgatewayunencrypted', {
                buztype: 5088,
                xingming: encodeURI(self.xingming),
                ybmapMessage: {
                  sjhm: self.tel,
                  zjhm: self.zjhm,
                  xingming: self.xingming,
                }
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  let _checkCount = function _checkCount() {
                    //验证码倒计时
                    if (self.countdown === 0) {
                      self.isSend = false;
                      self.countdown = 60;
                      return;
                    } else {
                      self.isSend = true;
                      self.countdown--;
                    }
                    setTimeout(function () {
                      _checkCount();
                    }, 1000);
                  };
                  _checkCount();
                } else {
                  self.$utils.alert(res.msg);
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            getSignUrl(){
              let self = this;

              sessionStorage.setItem("grzh",self.grzh);
              sessionStorage.setItem("xingming",self.xingming);
              sessionStorage.setItem("zjhm",self.zjhm);
              sessionStorage.setItem("coreUserId",self.coreUserId);
              sessionStorage.setItem("tqje",self.tqje);
              sessionStorage.setItem("tqgjjje",self.tqgjjje);
              sessionStorage.setItem("tqbtje",self.tqbtje);
              sessionStorage.setItem("showModel",self.showModel);
              sessionStorage.setItem("tel",self.tel);
              sessionStorage.setItem("loanShowObject",JSON.stringify(self.loanShowObject));
              sessionStorage.setItem("jsList",JSON.stringify(self.jsList));
              sessionStorage.setItem("jsShowList",JSON.stringify(self.jsShowList));
              sessionStorage.setItem("personList",JSON.stringify(self.personList));
              sessionStorage.setItem("personShowList",JSON.stringify(self.personShowList));

              sessionStorage.setItem("jumpType","eleSign");
              // 拼接参数
              let HDDZ = encodeURIComponent(window.location.href);
              let personData = [];
              personData.push(self.xingming +"~" + self.zjhm + "~" +"01");
              let QZSJ = {
                personData:personData
              }

              self.$http.post('/miapp/H3003/mpaasgatewayunencrypted', {
                buztype: 5088, //定值
                JKLX:'scan',  //定值
                YWLXDM:'13',
                YWSSJGDM:'000000',  //定值
                YWBLJGDM:'000000',  //定值
                BLQD:'app', //定值
                YWLCJD:'0',//定值
                AJTM:self.xingming,
                YWRQ:new Date().Format("yyyyMMdd"),
                time:new Date().getTime(),
                YWLSH:uuidv1(),
                SFZH:self.zjhm,
                DWZH:'',
                GRXM:self.xingming,
                WJDM:'TQXYCNS',
                pdf_type:'TQXYCNS',
                QZSJ:QZSJ,
                HDDZ:HDDZ,
                ybmapMessage: {}
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  window.location.replace(res.data);
                } else {
                  self.$utils.alert(res.msg);
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            jumpSignAfter(){
              let self = this;
              let jumpType = sessionStorage.getItem("jumpType");
              sessionStorage.setItem("jumpType","");
              if(this.$route.query.iscallback == '1' && jumpType == 'eleSign'){
                //说明从电子化签署回来的，代表签字过了
                self.grzh = sessionStorage.getItem("grzh");
                self.xingming = sessionStorage.getItem("xingming");
                self.zjhm = sessionStorage.getItem("zjhm");
                self.coreUserId = sessionStorage.getItem("coreUserId");
                self.tqje = sessionStorage.getItem("tqje");
                self.tqgjjje = sessionStorage.getItem("tqgjjje");
                self.tqbtje = sessionStorage.getItem("tqbtje");
                self.showModel = sessionStorage.getItem("showModel");
                self.tel = sessionStorage.getItem("tel");
                self.loanShowObject = JSON.parse(sessionStorage.getItem("loanShowObject"));
                self.jsList = JSON.parse(sessionStorage.getItem("jsList"));
                self.jsShowList = JSON.parse(sessionStorage.getItem("jsShowList"));
                self.personList = JSON.parse(sessionStorage.getItem("personList"));
                self.personShowList = JSON.parse(sessionStorage.getItem("personShowList"));

                sessionStorage.setItem("grzh","");
                sessionStorage.setItem("xingming","");
                sessionStorage.setItem("zjhm","");
                sessionStorage.setItem("coreUserId","");
                sessionStorage.setItem("tqje","");
                sessionStorage.setItem("tqgjjje","");
                sessionStorage.setItem("tqbtje","");
                sessionStorage.setItem("showModel","");
                sessionStorage.setItem("tel","");
                sessionStorage.setItem("loanShowObject","");
                sessionStorage.setItem("jsList","");
                sessionStorage.setItem("jsShowList","");
                sessionStorage.setItem("personList","");
                sessionStorage.setItem("personShowList","");
              }
            },
          }
    }
</script>

<style lang="stylus">
    .van-field__label
        width auto
        text-overflow ellipsis
        padding-right 12px
    .van-require-patch
        position relative
        width 100%
        &:before
            position absolute
            left 18px
            color #ee0a24
            font-size .32rem
            content '*'
    .van-cell-group__title
        color #518ede
        font-weight 400
    .van-cell__value
        flex 2
</style>
<style lang="stylus" scoped>
    .van-cell:not(:last-child)::after
        left 0
    .blank
        height .2rem
        display block
    .btn-wrap
        display flex
    .van-field
        flex-wrap nowrap
    .van-button--normal
        margin .3rem auto .2rem
    .van-cell__value
        word-break break-all
</style>